import React from 'react';
import SplitText from './SplitText';

const AboutUs: React.FC = () => {
  return (
    <section id="about-us" className="py-20 pb-24 md:pb-36 bg-light-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
              Una missione chiara
            </h2>
          </div>

          <div className="space-y-6 text-md sm:text-lg leading-relaxed text-gray-600">
            <p className="text-md sm:text-lg">
              Siamo una realtà nata per innovare il settore delle costruzioni. Conosciamo bene 
              le difficoltà quotidiane delle imprese: prezzi troppo alti, tempi lunghi, poca trasparenza.
            </p>
            <p className="text-md sm:text-lg">
              Con Synergy vogliamo rendere l'approvvigionamento dei materiali edili più semplice, 
              conveniente e sicuro.
            </p>
            <p className="text-md sm:text-lg">
              Il nostro obiettivo è creare valore per tutti: le imprese risparmiano senza rinunciare 
              alla qualità, i fornitori vendono di più e ricevono pagamenti rapidi.
            </p>
            <p className="text-md sm:text-lg">
              Crediamo che il futuro dell'edilizia sia fatto di collaborazione
            </p>
            <p className="text-3xl sm:text-3xl lg:text-4xl font-bold text-primary pt-8 text-center">
              <SplitText
                text="Costruire, Insieme."
                className="inline"
                animation="fade-up"
                delay={200}
                duration={0.8}
                stagger={0.05}
              />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
